import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, scrollToId, EASE } from "@/lib/site";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.2, ease: EASE }}
      className={`fixed top-0 inset-x-0 z-40 transition-[background-color,border-color,padding] duration-500 border-b ${
        scrolled ? "bg-[#0d0d0e]/80 backdrop-blur-xl border-[#d4a73c]/15 py-3" : "bg-transparent border-transparent py-6"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => window.__lenis?.scrollTo(0)} aria-label="Torna su">
          <Logo />
        </button>
        <nav className="hidden xl:flex items-center gap-8">
          {NAV.map(([label, id]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)}
              className="group relative text-sm text-[#e9e4da] hover:text-[#e8c063] transition-colors">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#d4a73c] transition-transform duration-500 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <button data-testid="nav-cta-preventivo" onClick={() => go("contatti")}
          className="hidden xl:inline-flex border border-[#d4a73c]/60 px-6 py-3 text-xs tracking-[0.25em] uppercase text-[#e8c063] hover:bg-[#d4a73c] hover:text-[#0d0d0e] transition-colors duration-500">
          Preventivo
        </button>
        <button data-testid="nav-mobile-toggle" className="xl:hidden text-[#e8c063]" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
            className="xl:hidden overflow-hidden bg-[#0d0d0e]/95 backdrop-blur-xl border-t border-[#d4a73c]/15">
            <div className="px-6 py-8 flex flex-col gap-5">
              {NAV.map(([label, id]) => (
                <button key={id} data-testid={`mobile-nav-link-${id}`} onClick={() => go(id)}
                  className="font-display text-3xl text-left text-[#f4f1ea] hover:text-[#e8c063]">{label}</button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
